import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { State } from '@app/store/state/state';
import { homeRootSelector } from '@home/store/selectors/home-root.selector';
import { fetchUserHistoryHomeAction } from '@home/store/actions/home.actions';
import { HomeDataResponse } from '@shared/home-sections/entities/home-data.response';
import { UiHomeState } from '@home/store/state/home-module.state';
import { getUserHomeState } from '@home/store/selectors/ui.selector';
import { resetWidgetDataAction } from '@shared/widgets/store/actions/alerts.action';
import { resetSalesChannelAction, searchBarActions } from '@shared/base-search-bar/store/actions/search-bar.actions';
import { disabledFlightScrollAction } from '@flight-results/store/actions/flights-results.actions';
import { UserHistoryFormatPipe } from '@app/pipes/user-history-format.pipe';

@Injectable()
export class HomeFacade {

  constructor(
    private store: Store<State>,
    private userHistoryFormatPipe: UserHistoryFormatPipe,
  ) { }

  public isLoadingHome$: Observable<boolean> = this.store
    .pipe(
      select(getUserHomeState),
      map((state: UiHomeState) => state.isLoadingHome)
    );

  public isLoadingHistory$: Observable<boolean> = this.store
    .pipe(
      select(getUserHomeState),
      map((state: UiHomeState) => state.isLoadingHistory)
    );


  public homeData$: Observable<HomeDataResponse> = this.store.pipe(
    select(homeRootSelector),
    map(state => state.homeData)
  );

  public fetchUserHistoryListByHome(): void {
    this.store.dispatch(fetchUserHistoryHomeAction());
  }

  public resetWidgetData(): void {
    this.store.dispatch(resetWidgetDataAction());
  }

  public resetSalesChannel(): void {
    this.store.dispatch(resetSalesChannelAction());
  }

  public resetAirline(): void {
    this.store.dispatch(searchBarActions.selectAirlineAction({ airlineCode: null }));
  }

  public disabledFlightScroll(payload: boolean = true): void {
    this.store.dispatch(disabledFlightScrollAction({ payload }));
  }

}
